import { IconGripVertical } from '@tabler/icons-react';

import { cn } from '@/utils/tailwind';

interface SixDotIconProps {
  position: string;
}

const SixDotIcon: React.FC<SixDotIconProps> = ({ position }) => (
  <div
    className={cn(
      'cursor-pointer',
      position === 'top' ? 'self-start' : 'self-center',
    )}
    data-testid="Draggable"
  >
    <IconGripVertical className="text-grayscale-gray3! -ml-1" />
  </div>
);

export default SixDotIcon;
